import JSONUtils from '../../lib/JSONUtils';
import safeNotifyPopupOpener from '../../lib/safeNotifyPopupOpener';
import { ROUTE_OAUTH_1A_AUTH } from '../../constants/pathnames';

export default function OAuth1aAuthenticator() {
  let url = window.location.href;
  let protocol = window.location.protocol;
  let host = window.location.host;
  let responseParams = url.replace(
    new RegExp(`${protocol}//${host}${ROUTE_OAUTH_1A_AUTH}[?#]`),
    '',
  );
  let queryJSON = JSONUtils.queryStringToJSON(responseParams);
  if (queryJSON) {
    safeNotifyPopupOpener(queryJSON, null);
    window.location.replace('about:blank');
    window.close();
  } else {
    safeNotifyPopupOpener(null, {
      code: 'Authentication error',
      description: 'Authentication error',
    });
    window.location.replace('about:blank');
    window.close();
  }
  return null;
}
